// File is used to authenticate customers and save there customer access token. 
// 2 functions allowing for customer access token saving when user logged in and when user registers.

window.authenticateCustomer = async function authenticateCustomer(email, password) {
  if (!email || !password) {
    console.error("Email or password missing");
    return;
  }

  const variables = { input: { email, password } };

  try {
    let customerAccessTokenCreateQuery = window.customerAccessTokenCreateQuery();

    const result = await sendGraphQLRequest(customerAccessTokenCreateQuery, variables);
    const tokenData = result.data.customerAccessTokenCreate;

    if (tokenData.customerAccessToken) {
      const accessToken = tokenData.customerAccessToken.accessToken;
      sessionStorage.setItem("customerAccessToken", accessToken);
      sessionStorage.removeItem("customerRegisterDetails");
      return accessToken;
    } else {
      alert(tokenData.userErrors.map(error => error.message).join("\n"));
      return null;
    }
  } catch (error) {
    console.error("Error processing customer authentication:", error);
    return null;
  }
}

window.handleCustomerAuth = function handleCustomerAuth(form, emailSelector, passwordSelector) {
  if (!form) return;

  const handleSubmit = async function (event) {
    event.preventDefault();

    const email = form.querySelector(emailSelector)?.value;
    const password = form.querySelector(passwordSelector)?.value;

    const token = await authenticateCustomer(email, password);

    if (token) {
      form.removeEventListener("submit", handleSubmit);
      form.submit();
    }
  };

  form.addEventListener("submit", handleSubmit);
};